import { NavLink, Outlet } from "react-router-dom";
import { Shield, LayoutDashboard, Package, Flag, Users, Truck, ClipboardList, MessageSquareWarning, BadgeCheck, FileText, Tag, Settings, Mail } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

const nav = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/reports", label: "Reports", icon: Flag, statKey: "reports_open" },
  { to: "/admin/verifications", label: "Verifications", icon: BadgeCheck, statKey: "verifications_pending" },
  { to: "/admin/listings", label: "Listings", icon: Package, statKey: "listings_pending" },
  { to: "/admin/users", label: "Users", icon: Users },
  { to: "/admin/companies", label: "Removal firms", icon: Truck, statKey: "companies_pending" },
  { to: "/admin/briefs", label: "Clearance requests", icon: ClipboardList },
  { to: "/admin/reviews", label: "Reviews", icon: MessageSquareWarning },
  { to: "/admin/invoices", label: "Invoices", icon: FileText },
  { to: "/admin/offers", label: "Offers & discounts", icon: Tag },
  { to: "/admin/email-templates", label: "Email templates", icon: Mail },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const [stats, setStats] = useState({});
  useEffect(() => {
    const load = () => api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-8">
      <div className="border border-forest bg-forest text-white p-6 lg:p-8 flex items-center gap-4">
        <Shield className="w-6 h-6 text-safety" />
        <div>
          <div className="overline text-safety">Admin console</div>
          <div className="font-display font-black text-2xl tracking-tighter">Furniture Exchange · moderation</div>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-[240px,1fr] gap-6">
        <aside className="border border-border bg-white h-fit">
          {nav.map((n) => {
            const badge = n.statKey ? stats[n.statKey] : null;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center justify-between px-5 py-3 text-sm border-b border-border last:border-b-0 transition-colors duration-200 ${
                    isActive ? "bg-forest text-white" : "hover:bg-sage-light"
                  }`
                }
              >
                <span className="flex items-center gap-3">
                  <n.icon className="w-4 h-4" /> {n.label}
                </span>
                {badge != null && badge > 0 && (
                  <span className="bg-safety text-white text-[10px] px-2 py-0.5 overline tabular-nums">{badge}</span>
                )}
              </NavLink>
            );
          })}
        </aside>
        <section className="min-w-0">
          <Outlet context={{ stats }} />
        </section>
      </div>
    </div>
  );
}
